import { render, staticRenderFns } from "./modalSeleccionarLeechero.vue?vue&type=template&id=3bba5406&scoped=true&"
import script from "./modalSeleccionarLeechero.vue?vue&type=script&lang=js&"
export * from "./modalSeleccionarLeechero.vue?vue&type=script&lang=js&"
import style0 from "./modalSeleccionarLeechero.vue?vue&type=style&index=0&id=3bba5406&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bba5406",
  null
  
)

export default component.exports